const ChartHeading = ({ heading }) => {
  return (
    <div className="d-flex justify-content-between">
      <h3 className="bold mt-4 align-items-center">
        <span>{heading}</span>
      </h3>
    </div>
  );
};
export default ChartHeading;
